import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import moment from 'moment';


const MessageExpirationBarPropTypes = {
  displayedAt: MomentPropTypes.momentObj.isRequired,
  expiration: MomentPropTypes.momentObj.isRequired,
  messageType: PropTypes.string.isRequired,
};

const MessageExpirationBar = ({ displayedAt, expiration, messageType }) => {
  const totalDuration = expiration.diff(displayedAt);
  const [remainingDuration, setRemainingDuration] = useState(expiration.diff(moment.utc()));
  const progress = ((totalDuration - remainingDuration) / totalDuration) * 100;

  const updateRemainingDuration = useCallback(
    () => setRemainingDuration(expiration.diff(moment.utc())),
    [expiration],
  );

  useEffect(() => {
    const interval = setInterval(updateRemainingDuration, 10);
    return () => clearInterval(interval);
  }, [updateRemainingDuration]);

  let color = '';
  if (messageType === 'success') color = 'jade';
  if (messageType === 'error') color = 'red';

  return (
    <li className="timer">
      <div className={`elapsed-time ${color}`} style={{ width: `${progress}%` }} />
    </li>
  );
};

MessageExpirationBar.propTypes = MessageExpirationBarPropTypes;


export default MessageExpirationBar;
